import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import {
  getCanonical, getMeta, getPage, organization,
} from '../seo';

/** Keeps metadata in sync when React Router navigates without reloading the document. */
const PageMetadata = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const page = getPage(pathname);
    document.title = page.title;
    document.head.querySelectorAll('[data-seo], meta[name="description"], meta[name="keywords"], meta[name="robots"]')
      .forEach((element) => element.remove());

    getMeta(page).forEach(({ name, property, content }) => {
      const meta = document.createElement('meta');
      if (name) {
        meta.name = name;
      }
      if (property) {
        meta.setAttribute('property', property);
      }
      meta.content = content;
      meta.setAttribute('data-seo', '');
      document.head.appendChild(meta);
    });

    const canonical = getCanonical(page);
    if (canonical) {
      const link = document.createElement('link');
      link.rel = 'canonical';
      link.href = canonical;
      link.setAttribute('data-seo', '');
      document.head.appendChild(link);
    }

    if (page.path === '/') {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(organization);
      script.setAttribute('data-seo', '');
      document.head.appendChild(script);
    }
  }, [pathname]);

  return null;
};

export default PageMetadata;
